import { createCrudSagas } from "./CrudSagas";
import { StateValuesActions } from "../reducers/StateValuesRedux";

const crudSagas = createCrudSagas("stateValues", StateValuesActions);

export const findStateValues = crudSagas.findStateValues;
export const getStateValue = crudSagas.getStateValue;
export const watchStateValues = crudSagas.watchStateValues;
export const unwatchStateValues = crudSagas.unwatchStateValues;